export const containerWidth = "xl:max-w-[1280px] mx-auto lg:px-0";
